import { Save, X } from "lucide-react"

import { Button } from "@/components/ui/button.tsx"

import type { Farm } from "../types/logisticsTypes.ts"

export default function FarmTargetRow({ farm }: { farm: Farm }) {
  return (
    <div className="flex justify-between items-center has-[:focus]:bg-muted p-2 hover:bg-muted/50">
      {farm.name}
      <div className="flex gap-2 items-center">
        <Button variant="outline">
          <X />
          Cancel
        </Button>
        <Button variant="outline">
          <Save />
          Save
        </Button>
      </div>
    </div>
  )
}
